import React, { useEffect, useState } from "react";
import "./Planes.css";

// MODAL PARA AGREGAR PLAN
import ModalAgregarPlan from "../components/ModalAgregarPlan";

// TOAST
import Toast from "../components/Toast";
import { authFetch } from "../utils/authFetch";
import {
  AccionFila, BarraFiltros, Boton, EncabezadoPagina, Iconos,
} from "../componentes/base";

export default function Planes() {
  const [planes, setPlanes] = useState([]);
  const [olts, setOlts] = useState([]);
  const [busqueda, setBusqueda] = useState("");
  const [pagina, setPagina] = useState(1);
  const porPagina = 10;

  const [mostrarModal, setMostrarModal] = useState(false);
  const [toast, setToast] = useState(null);

  /* ================================
     CARGAR PLANES
  ================================= */
  async function cargarPlanes() {
    try {
      const res = await authFetch("/api/planes/listar");
      const data = await res.json();
      if (data.ok) setPlanes(data.planes);
    } catch (error) {
      console.log("Error cargando planes:", error);
    }
  }

  async function cargarOlts() {
    try {
      const res = await authFetch("/api/olt-config/");
      const data = await res.json();
      if (Array.isArray(data.olts)) setOlts(data.olts);
    } catch (error) {
      console.log("Error cargando OLTs:", error);
    }
  }

  useEffect(() => {
    cargarPlanes();
    cargarOlts();
  }, []);

  // El nombre del nodo, no su número: "Moroleón" dice más que "2".
  function nombreOlt(id) {
    const o = olts.find((x) => x.id === id);
    return o ? (o.nombre || o.host) : (id ?? "—");
  }

  /* ================================
     FILTRO
  ================================= */
  const filtrados = planes.filter((p) =>
    `${nombreOlt(p.olt_id)} ${p.nombre} ${p.velocidad} ${p.costo}`
      .toLowerCase()
      .includes(busqueda.toLowerCase())
  );

  /* ================================
     PAGINACIÓN
  ================================= */
  const totalPaginas = Math.ceil(filtrados.length / porPagina);
  const planesPagina = filtrados.slice((pagina - 1) * porPagina, pagina * porPagina);

  /* ================================
     GUARDAR PLAN NUEVO
  ================================= */
  async function guardarPlan(form) {
    try {
      const res = await authFetch("/api/planes/nuevo", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      const data = await res.json();

      if (data.ok) {
        setToast({ mensaje: "Plan creado correctamente", tipo: "success" });
        setMostrarModal(false);
        cargarPlanes();
      } else {
        setToast({ mensaje: "Error: " + data.mensaje, tipo: "error" });
      }
    } catch (error) {
      setToast({ mensaje: "Error al crear plan", tipo: "error" });
    }
  }

  /* ================================
     RENDER
  ================================= */
  return (
    <div className="planes-page">
      <EncabezadoPagina
        icono={Iconos.planes}
        titulo="Planes"
        resumen={`${planes.length} plan${planes.length === 1 ? "" : "es"} configurado${planes.length === 1 ? "" : "s"}`}
        acciones={
          <Boton icono={Iconos.agregar} onClick={() => setMostrarModal(true)}>
            Agregar plan
          </Boton>
        }
      />

      <BarraFiltros
        valor={busqueda}
        onBuscar={(v) => {
          setBusqueda(v);
          setPagina(1);
        }}
        placeholder="Buscar plan o nodo…"
      />

      <table className="planes-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Nodo</th>
            <th>Plan</th>
            <th>Velocidad</th>
            <th>Costo</th>
            <th>VLAN</th>
            <th>Gemport</th>
            <th>Line Profile</th>
            <th>Service Profile</th>
            <th>Traffic UP</th>
            <th>Traffic DOWN</th>
            <th>Acciones</th>
          </tr>
        </thead>

        <tbody>
          {/* La clave es la del par plan+nodo: `p.id` es el del producto y se
              repite en cada nodo donde está dado de alta, así que por sí solo
              haría que dos filas compartan identidad ante React. */}
          {planesPagina.map((p) => (
            <tr key={p.plan_olt_id ?? `${p.id}-${p.olt_id}`}>
              <td>{p.id}</td>
              {/* Con dos nodos, dos filas pueden llamarse igual y tener
                  VLANs distintas. Sin esta columna no hay forma de saber
                  cuál se está mirando. */}
              <td>{nombreOlt(p.olt_id)}</td>
              <td>{p.nombre}</td>
              <td>{p.velocidad} Mbps</td>
              <td>${p.costo}</td>
              <td>{p.vlan}</td>
              <td>{p.gemport}</td>
              <td>{p.line_profile}</td>
              <td>{p.srv_profile}</td>
              <td>{p.traffic_up}</td>
              <td>{p.traffic_down}</td>
              <td>
                <div className="acciones">
                {/* ⚠️ Este botón nunca ha tenido `onClick`: se ve, se puede
                    pulsar y no hace nada. Tampoco existe el endpoint
                    DELETE en `planes_controller.py`. Se deja deshabilitado
                    para que no engañe, hasta que se decida si borrar un
                    plan debe ser posible (hay clientes colgando de él). */}
                <AccionFila
                  icono={Iconos.eliminar}
                  titulo="Borrar plan (no disponible todavía)"
                  peligro
                  disabled
                />
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* PAGINACIÓN */}
      <div className="paginacion">
        <button
          disabled={pagina === 1}
          onClick={() => setPagina(pagina - 1)}
          aria-label="Página anterior"
        >
          <Iconos.atras size={15} strokeWidth={2} />
        </button>

        <span>Página {pagina} de {totalPaginas}</span>

        <button
          disabled={pagina === totalPaginas}
          onClick={() => setPagina(pagina + 1)}
          aria-label="Página siguiente"
        >
          <Iconos.adelante size={15} strokeWidth={2} />
        </button>
      </div>

      {/* MODAL */}
      {mostrarModal && (
        <ModalAgregarPlan
          onClose={() => setMostrarModal(false)}
          onGuardar={guardarPlan}
        />
      )}

      {/* TOAST */}
      {toast && (
        <Toast
          mensaje={toast.mensaje}
          tipo={toast.tipo}
          onClose={() => setToast(null)}
        />
      )}
    </div>
  );
}
